import { Component, Input } from '@angular/core';

// This component is for using inserting Youtube embed scripts.
// It accepts parameters from CMS to control the player
// it uses the https://www.npmjs.com/package/lite-youtube-embed package to load the youtube ifram on click

@Component({
    selector: 'app-youtube-player',
    template: `
        <div class="youtube-player" *ngIf="videoId">
            <div *ngIf="!autoplay; else iFrameIt" [innerHtml]="generateVideoHtml | safe: 'html'"></div>
            <ng-template #iFrameIt>
                <iframe
                    class="youtube-player__video"
                    [src]="generateVideoPath | safe: 'resourceUrl'"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                >
                </iframe>
            </ng-template>
        </div>
    `,
})
export class YoutubePlayerComponent {
    @Input() videoId: string;
    @Input() autoplay: boolean;

    get generateVideoHtml() {
        return `<lite-youtube videoid="${this.videoId}" style="background-image: url('https://i.ytimg.com/vi/${this.videoId}/maxresdefault.jpg');"></lite-youtube>`;
    }

    get generateVideoPath() {
        // autoplay=${+!!this.autoplay} converts a boolean in to a 0|1. Needed for youtube
        return `https://www.youtube.com/embed/${this.videoId}?autoplay=${+!!this.autoplay}`;
    }
}
